// @flow
import React from 'react';
import { h, render, Component } from 'preact';

export default class CheckBoxField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: false,
    };
  }

  render() {
    const formfield = this.props.formfield;
    const name = formfield ? formfield.name : this.props.name;
    const label = formfield ? `${formfield.description}${this.props.required ? " *" : ""}` : this.props.label
    // parse choices and build corresponding sub components

    return (
      <div id={this.props.fieldId} className={`checkboxBlock ${name}`}>
        <label className="checkBoxLabel">
          <div
            className={`checkbox ${this.state.value ? 'checked' : ''}`}
          />
          <span className={`checkboxLabel ${name}`} dangerouslySetInnerHTML={{__html: label}} />
          <input
            id={`formfield_${name}`}
            name={`formfield_${name}`}
            style={{display: 'none'}}
            type={'checkbox'}
            value={this.state.value}
            onChange={(e) => this.onChange(e, name)}
          />
        </label>
      </div>
    );
  }

  onChange = (e, name) => {
    if (e && e.target) {
      this.props.handleFieldChange(name, e.target.checked);
      this.setState({ value: e.target.checked });
    }
  }
}
